import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import InvoiceDialog, { ReceiptStatus, SendWhatsAppButton } from "./Invoice";
import { SYNC_LABEL, SYNC_TONE, fmtTime, rp } from "./util";

export default function TxnDialog({ txn, onClose, reload }) {
    const [invoice, setInvoice] = useState(false);
    return (
        <Dialog open={!!txn} onOpenChange={(o) => !o && onClose()}>
            <DialogContent className="max-w-lg" data-testid="pos-txn-dialog">
                <DialogHeader><DialogTitle className="font-serif text-xl">{txn?.number}</DialogTitle></DialogHeader>
                {txn && (
                    <div className="space-y-3 text-sm">
                        <div className="grid grid-cols-2 gap-2 text-xs">
                            <p><span className="text-neutral-500">Time</span><br />{fmtTime(txn.created_at)}</p>
                            <p><span className="text-neutral-500">Payment</span><br />{txn.payment_method}</p>
                            <p><span className="text-neutral-500">Customer</span><br />{txn.customer_name}</p>
                            <p><span className="text-neutral-500">WhatsApp</span><br />{txn.customer_wa}</p>
                            <p><span className="text-neutral-500">Sync</span><br /><span className={SYNC_TONE[txn.sync_status]} data-testid="pos-txn-sync">{SYNC_LABEL[txn.sync_status]}</span>{txn.sync_error ? ` · ${txn.sync_error}` : ""}</p>
                        </div>
                        <ReceiptStatus txn={txn} />
                        <div className="divide-y divide-mist border-y border-mist">
                            {txn.items.map((x) => (
                                <div key={x.item_id} className="flex justify-between gap-3 py-2">
                                    <div className="min-w-0"><p className="truncate">{x.name}</p><p className="text-[11px] text-neutral-500">{[x.variant, x.sku].filter(Boolean).join(" · ")} · {x.qty} × {rp(x.price)}</p></div>
                                    <span className="shrink-0">{rp(x.line_total)}</span>
                                </div>
                            ))}
                        </div>
                        <div className="flex justify-between font-semibold"><span>Total</span><span data-testid="pos-txn-total">{rp(txn.total)}</span></div>
                        <div className="grid grid-cols-2 gap-2">
                            <button onClick={() => setInvoice(true)} data-testid="pos-view-invoice" className="h-12 rounded-md bg-sage-dark text-white text-xs font-semibold uppercase tracking-wider hover:opacity-90">View Invoice</button>
                            {!txn._server && <SendWhatsAppButton txn={txn} reload={reload} className="w-full" />}
                        </div>
                    </div>
                )}
                <InvoiceDialog txn={invoice ? txn : null} reload={reload} onClose={() => setInvoice(false)} />
            </DialogContent>
        </Dialog>
    );
}
